import { Typography } from '@mui/material';
import { memo } from 'react';

interface ReplyTextPreviewProps {
  content: string;
}

export const ReplyTextPreview = memo<ReplyTextPreviewProps>(({ content }) => {
  const truncatedContent = content.length > 50 ? `${content.substring(0, 50)}...` : content;

  return (
    <Typography variant='body2' noWrap sx={{ color: 'text.primary' }}>
      {truncatedContent}
    </Typography>
  );
});
